// extracted by mini-css-extract-plugin
export default {"SwitchText":"configurations_SwitchText__gnSh5"};